module.exports = __webpack_public_path__ + "img/root10.12c6cd0b.png";